function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { Quill } from 'seagull/patches/PatchedQuill';
import styles from "./TemplateVariableBlot.module.scss";

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const Embed = Quill.import('blots/embed');
class TemplateVariableBlot extends Embed {
  static create(value) {
    var _value$label;
    if (!((_value$label = value.label) !== null && _value$label !== void 0 && _value$label.trim())) {
      throw new Error('TemplateVariableBlot: label must be non-empty');
    }
    const node = super.create();
    node.setAttribute('data-label', value.label);
    node.setAttribute('contenteditable', 'false');
    node.textContent = value.label;
    node.setAttribute('aria-label', "Variable: ".concat(value.label));
    return node;
  }
  static value(node) {
    return {
      label: node.getAttribute('data-label') || ''
    };
  }
  text() {
    const data = TemplateVariableBlot.value(this.domNode);
    return "{{".concat(data.label, "}}");
  }
}
_defineProperty(TemplateVariableBlot, "blotName", 'template-variable');
_defineProperty(TemplateVariableBlot, "tagName", 'span');
_defineProperty(TemplateVariableBlot, "className", styles.templateVariable);
Quill.register('blots/template-variable', TemplateVariableBlot, true);
export default TemplateVariableBlot;